import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './PricingCards.css';

// All available modules with icons
const allModules = [
  { name: 'Financial Management', icon: '💼' },
  { name: 'Stock Control', icon: '📦' },
  { name: 'Production', icon: '🏭' },
  { name: 'Gate Control', icon: '🚪' },
  { name: 'Procurement Management', icon: '🛒' },
  { name: 'Sales', icon: '💰' },
  { name: 'Trasporter', icon: '🚚' },
  { name: 'Transporter', icon: '🚚' },
  { name: 'Job Work', icon: '👷' },
  { name: 'Payroll', icon: '💵' },
  { name: 'Administrator Module', icon: '🔑' },
  { name: 'Custom Module Selection', icon: '🛠️' },
  { name: 'Tailored Integration', icon: '🧩' },
  { name: 'All Enterprise Modules Available', icon: '📚' },
  { name: 'Custom Development', icon: '⚙️' }
];

const getModuleWithIcon = (moduleName) => {
  const module = allModules.find(m => m.name === moduleName);
  return module || { name: moduleName, icon: '✓' };
};

const PricingCards = (props) => {
  const history = useNavigate();
  const location = useLocation();
  const [plans, setPlans] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', message: '', company: '', phone: '' });
  const [expandedCards, setExpandedCards] = useState({});
  const { userCode } = location.state || {}; // Access the userCode from state
  console.log("User Code:", userCode);

  useEffect(() => {
    axios.get(`${props.url}/api/v1/users/getPlan`)
      .then(res => {
        console.log("Plans loaded:", res.data);
        setPlans(res.data);
      })
      .catch(err => {
        console.error("Failed to load plans:", err);
      });
  }, [props.url]);

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const toggleModuleView = (planKey) => {
    setExpandedCards({
      ...expandedCards,
      [planKey]: !expandedCards[planKey]
    });
  };

  const initiateRazorpay = async (key) => {
    const plan = plans[key];
    const userCode = location.state?.userCode; // Get userCode from location state
    const planId = plan.id; // Plan id
    const amount = plan.amount / 100; // Convert amount (if it's in paise to rupees)
  
    console.log("Plan ID:", planId, "Amount:", amount, "User Code:", userCode);
  
    if (userCode && planId) {
      try {
        const response = await axios.post(`${props.url}/api/v1/users/payemnrt`, {
          plan_id: planId,
          user_code: userCode,
          amount: amount
        });
  
        console.log("Payment API Response:", response.data);
  
        if (response.status === 200 && response.data) {
          alert(`Payment for ${plan.name} would be initiated here.`);
  
          // TODO: Razorpay integration can happen here, using data like order_id, amount, etc.
          // Example:
          // const razorpayOptions = { ... };
          // const rzp = new window.Razorpay(razorpayOptions);
          // rzp.open();
          history("/admin/dashboard",  { state: { email: userCode }  });
        } else {
          alert('Subscription failed. Please try again.');
        }
      } catch (error) {
        console.error('Failed to subscribe:', error);
        alert('Something went wrong. Please try again.');
      }
    } else {
      alert('Missing required information to process the subscription.');
    }
  };
  

  const startFreeTrial = (planKey) => {
    localStorage.setItem('selectedPlan', planKey);
    window.location.href = '/signup';
  };

  const openCustomRequestModal = (planKey) => {
    setSelectedPlan(planKey);
    setShowModal(true);
  };

  const submitCustomRequest = (e) => {
    e.preventDefault();
    alert(`Thank you, ${form.name}! Our sales team will reach out to you about the ${plans[selectedPlan].name}.`);
    setForm({ name: '', email: '', message: '', company: '', phone: '' });
    setShowModal(false);
  };

  return (
    <div className="pricing-container">
      {Object.keys(plans).length === 0 ? (
        <p>Loading plans...</p>
      ) : (
        <div className="pricing-grid">
          {Object.entries(plans).map(([key, plan]) => {
            const isExpanded = expandedCards[key];
            const displayModules = isExpanded ? plan.modules : plan.modules.slice(0, 4);
            const hasMoreModules = plan.modules.length > 4;

            return (
              <div key={key} className={`pricing-card ${key === 'professional' ? 'recommended' : ''}`}>
                {plan.highlight && (
                  <div className="plan-highlight">
                    <span>{plan.highlight}</span>
                  </div>
                )}

                <div className="pricing-header">
                  <h3>{plan.name}</h3>
                  {plan.tagline && <p className="plan-tagline">{plan.tagline}</p>}

                  {plan.amount ? (
                    <div className="price-container">
                      <div className="price">₹{plan.amount / 100}</div>
                      <div className="price-duration">/month</div>
                    </div>
                  ) : (
                    <div className="price-container">
                      <div className="price">Contact Us</div>
                      <div className="price-duration">Tailored Solution</div>
                    </div>
                  )}
                </div>

                <div className="pricing-features">
                  <ul>
                    {displayModules.map((moduleName, i) => {
                      const module = getModuleWithIcon(moduleName);
                      return (
                        <li key={i}>
                          <span className="feature-icon">{module.icon}</span>
                          <span className="feature-text">{module.name}</span>
                        </li>
                      );
                    })}
                  </ul>

                  {hasMoreModules && (
                    <button className="btn btn-secondary" onClick={() => toggleModuleView(key)}>
                      {isExpanded ? 'Show Less' : `Show ${plan.modules.length - 4} More Features`}
                    </button>
                  )}

                  <div className="pricing-action">
                    <button className="btn btn-trial" onClick={() => startFreeTrial(key)}>
                      Start 15-Day Free Trial
                    </button>

                    {key === 'custom' ? (
                      <button className="btn btn-primary" onClick={() => openCustomRequestModal(key)}>
                        Contact Sales
                      </button>
                    ) : (
                      <button className="btn btn-primary" onClick={() => initiateRazorpay(key)}>
                        Subscribe Now
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
            <h3>Tell Us About Your Requirements</h3>
            <p className="modal-subtitle">Our team will create a custom solution for your business needs</p>

            <form onSubmit={submitCustomRequest}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Your Name</label>
                  <input type="text" id="name" name="name" value={form.name} onChange={handleInputChange} required />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Your Email</label>
                  <input type="email" id="email" name="email" value={form.email} onChange={handleInputChange} required />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="company">Company</label>
                  <input type="text" id="company" name="company" value={form.company} onChange={handleInputChange} />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input type="tel" id="phone" name="phone" value={form.phone} onChange={handleInputChange} />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">Your Requirements</label>
                <textarea id="message" name="message" value={form.message} onChange={handleInputChange} rows="4" required />
              </div>

              <div className="modal-buttons">
                <button type="submit" className="btn btn-primary">Submit Request</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingCards;
